import { useState } from 'react';

// Mock type for demo
interface ProductImage {
  _id: string;
  url?: string;
  data?: string;
}

interface ProductImageGalleryModalProps {
  images: ProductImage[];
  productName: string;
}

export function ProductImageGalleryModal({ images, productName }: ProductImageGalleryModalProps) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  if (!images || images.length === 0) {
    return null;
  }

  const mainImage = images[selectedIndex] || images[0];
  
  // Handle both url and data properties
  const getImageUrl = (image: ProductImage) => {
    return image.url || image.data || '';
  };

  return (
    <div className="flex flex-col gap-2">
      {/* Main Image with responsive aspect ratio */}
      <div className="relative w-full rounded-[10px] overflow-hidden bg-gray-100 aspect-square sm:aspect-[4/3]">
        <img
          src={getImageUrl(mainImage)}
          alt={productName}
          className="w-full h-full object-contain"
        />
      </div>

      {/* Thumbnail Gallery */}
      {images.length > 1 && (
        <div className="flex gap-2 overflow-x-auto scrollbar-hide pb-1">
          {images.map((image, index) => (
            <button
              key={image._id}
              onClick={() => setSelectedIndex(index)}
              className={`
                flex-shrink-0 w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] rounded-[8px] overflow-hidden border-2 transition-all
                ${
                  index === selectedIndex
                    ? 'border-primary-green'
                    : 'border-transparent hover:border-gray-300'
                }
              `}
            >
              <img
                src={getImageUrl(image)}
                alt={`${productName} view ${index + 1}`}
                className="w-full h-full object-cover"
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

